import {
  ControlledDateInput,
  ControlledInput,
} from "components/Card/ControlledInput";
import { Checkbox, MaskedInput } from "components/inputs";
import ControlledSelect from "components/inputs/Select/ControlledSelect";
import type {
  Control,
  UseFormGetValues,
  UseFormSetValue,
} from "react-hook-form";
import type { ConstantTypes } from "types/DataTypes";

import type { LienFormValues } from "../../LienTypes";

type CPLSectionProps = {
  control: Control<LienFormValues>;
  getValues: UseFormGetValues<LienFormValues>;
  setValue: UseFormSetValue<LienFormValues>;
  handleFieldChange: (field: string | null, value: unknown) => Promise<void>;
  constants?: ConstantTypes;
};

const CPLSection = ({
  control,
  getValues,
  setValue,
  handleFieldChange,
  constants,
}: CPLSectionProps) => {
  const cplReceived = getValues("cpl_received") ?? false;

  const appealResultOptions = constants?.CRCAppealResultChoices || [];

  return (
    <>
      <Checkbox
        name="cpl_received"
        label="CPL Received"
        checked={getValues("cpl_received")}
        required={false}
        onChange={async (e) => {
          setValue("cpl_received", e.target.checked);
          if (!e.target.checked) {
            setValue("cpl_dispute_date", null);
            setValue("cpl_result", null);
            setValue("cpl_appeal_result_dollar_amount", null);
            setValue("cpl_savings", null);
            setValue("cpl_total_disputed", null);
            setValue("cpl_amount", null);
            await handleFieldChange(null, {
              cpl_received: false,
              cpl_dispute_date: null,
              cpl_result: null,
              cpl_appeal_result_dollar_amount: null,
              cpl_savings: null,
              cpl_total_disputed: null,
              cpl_amount: null,
            });
          } else {
            await handleFieldChange("cpl_received", e.target.checked);
          }
        }}
      />

      {cplReceived && (
        <>
          <ControlledDateInput
            control={control}
            name="cpl_date_issued"
            label="CPL Date"
            errors={{}}
            allowFutureDates
            onSave={(value) => handleFieldChange("cpl_date_issued", value)}
          />
          <ControlledInput
            control={control}
            name="cpl_amount"
            label="CPL Amount"
            errors={{}}
            onSave={(value) => handleFieldChange("cpl_amount", value)}
            componentType={MaskedInput}
            mask="dollar"
          />
          <ControlledInput
            control={control}
            name="cpl_total_disputed"
            label="CPL Total Disputed"
            errors={{}}
            onSave={(value) => handleFieldChange("cpl_total_disputed", value)}
            componentType={MaskedInput}
            mask="dollar"
            readOnly
          />
          <ControlledInput
            control={control}
            name="cpl_amount_due"
            label="CPL Amount Due"
            errors={{}}
            onSave={(value) => handleFieldChange("cpl_amount_due", value)}
            componentType={MaskedInput}
            mask="dollar"
            readOnly
          />
          <ControlledDateInput
            control={control}
            name="cpl_dispute_date"
            label="CPL Dispute Date"
            errors={{}}
            allowFutureDates
            onSave={(value) => handleFieldChange("cpl_dispute_date", value)}
          />

          <ControlledSelect
            control={control}
            name="cpl_result"
            label="CPL Result"
            errors={{}}
            options={appealResultOptions}
            onSave={(value) =>
              handleFieldChange("cpl_result", value?.value || null)
            }
          />

          <ControlledInput
            control={control}
            name="cpl_appeal_result_dollar_amount"
            label="CPL Appeal Result Dollar Amount"
            errors={{}}
            onSave={(value) =>
              handleFieldChange("cpl_appeal_result_dollar_amount", value)
            }
            componentType={MaskedInput}
            mask="dollar"
          />

          <ControlledInput
            control={control}
            name="cpl_savings"
            label="CPL Savings"
            errors={{}}
            onSave={(value) => handleFieldChange("cpl_savings", value)}
            componentType={MaskedInput}
            mask="dollar"
            readOnly
          />
        </>
      )}
    </>
  );
};

export default CPLSection;
